import BankOutlined from '@ant-design/icons/BankOutlined'
import CloseOutlined from '@ant-design/icons/CloseOutlined'
import DeleteOutlined from '@ant-design/icons/DeleteOutlined'
import EditOutlined from '@ant-design/icons/EditOutlined'
import FileTextOutlined from '@ant-design/icons/FileTextOutlined'
import PlusOutlined from '@ant-design/icons/PlusOutlined'
import TeamOutlined from '@ant-design/icons/TeamOutlined'
import UploadOutlined from '@ant-design/icons/UploadOutlined'
import UserOutlined from '@ant-design/icons/UserOutlined'
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  Row,
  Space,
  Tabs,
  Tag,
  Tooltip,
  Upload,
  message,
} from 'antd'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import React, {
  memo,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react'
import { blue, redPrimary } from '../../../color'
import { AvatarHasName } from '../../../components/Common/Avatar'
import RichEditor from '../../../components/RichEditor/RichEditor'
import SelectPeoplePopup from '../../../components/SelectPeoplePopup'
import { ASSIGNEE_TYPE, FEEDBACK_STATUS } from '../../../constants'
import { SelectList } from '../InternalDocumentOutgoingDocCreatePage/InternalDocumentOutgoingDocCreatePageStyled'
import {
  FileAction,
  FileItem,
  SignDocumentList,
} from '../InternalDocumentSignDocDetailPage/InternalDocumentSignDocDetailPageStyled'
import ExportPdf from './ExportPdf/ExportPdf'
import {
  getBoardTypeByTab,
  getPlykSuffixByTab,
  toDisplayDocumentNumber,
  toStorageDocumentNumberByTab,
} from './feedbackBoardType'
import { AddCircleOutlineIcon } from '../../../components/AppIcon'
import DraggerUploadButton from '../../../components/Common/DraggerUploadButton'

const FeedbackBoardUpdate = ({
  handleCancel,
  isVisible,
  feedbackDetailData,
  selectPeopleStore,
  fileStore,
  FeedbackProcedureStore,
  loadingAnimationStore,
  userGroupStore,
  authenticationStore,
  fetchFeedback,
  setIsVisible,
  assignees,
  finalUserList,
  selectedOption,
  fullNamecreator,
  feedbackTab,
}) => {
  const {
    selectUserData,
    selectDepartmentData,
    selectGroupData,
    isVisibleSelectUserDepartmentPopup,
    setIsVisibleSelectUserDepartmentPopup,
    handleOpenSelectUserDepartmentPopup,
    handleCancelSelectUserDepartment,
    originDepartmentWithUserList,
    clearSelected,
    clearSelectUserData,
    originGroupList,
  } = selectPeopleStore
  const { allDataGroupList } = userGroupStore
  const [form] = Form.useForm()
  const BASIS_REF = useRef(null)
  const PURPOSE_REF = useRef(null)
  const ATTACHED_REF = useRef(null)
  const OTHER_REF = useRef(null)
  const [fileList, setFileList] = useState([])
  const [expailFile, setExpailFile] = useState([])
  const [originalFileList, setOriginalFileList] = useState([])
  const [originalExpailFile, setOriginalExpailFile] = useState([])
  const [opinionContent, setOpinionContent] = useState(null)
  const [basis, setBasis] = useState(null)
  const [purpose, setPurpose] = useState(null)
  const [attachedDocs, setAttachedDocs] = useState(null)
  const [otherContent, setOtherContent] = useState(null)
  const [handlerList, setHandlerList] = useState([])
  const [followerList, setFollowerList] = useState([])
  const [combinerList, setCombinerList] = useState([])
  const [isSubmitting, setIsSubmitting] = useState(false)
  const otherContentRefs = useRef([])
  const [otherContentList, setOtherContentList] = useState([
    { id: 1, content: null },
  ])
  const [submitData, setSubmitData] = useState(null)

  const [legalBasisExport, setLegalBasisExport] = useState()
  const [attachedDocsExport, setAttachedDocsExport] = useState()
  const [otherContentExport, setOtherContentExport] = useState()
  const [commentExport, setCommentExport] = useState([])
  const [feedbackNumber, setFeedbackNumber] = useState()

  useEffect(() => {
    ;(async () => {
      await clearSelectUserData()
      await setFollowerList([])
      await setCombinerList([])
      await clearSelected()
    })()
  }, [])

  const processedAssignees = useMemo(() => {
    if (!assignees || !finalUserList) return assignees

    return assignees.map(el => {
      const user = finalUserList.find(
        user => user.username === el.assignee_code
      )
      if (user) {
        return { ...el, name_uppercase: user.name_uppercase }
      }
      return el
    })
  }, [assignees, finalUserList])

  const userList = useMemo(() => {
    return processedAssignees
      ? processedAssignees.filter(
          el =>
            el.assignee_type === ASSIGNEE_TYPE.USER &&
            el.permission !== ASSIGNEE_TYPE.CREATE
        )
      : []
  }, [processedAssignees])

  const departmentList = useMemo(() => {
    return processedAssignees
      ? processedAssignees.filter(
          el => el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT
        )
      : []
  }, [processedAssignees])

  const groupList = useMemo(() => {
    return processedAssignees
      ? processedAssignees.filter(
          el => el.assignee_type === ASSIGNEE_TYPE.GROUP
        )
      : []
  }, [processedAssignees])

  useEffect(() => {
    const combinedHandlerList = [
      ...selectUserData[ASSIGNEE_TYPE.HANDLER],
      ...selectDepartmentData[ASSIGNEE_TYPE.HANDLER],
      ...selectGroupData[ASSIGNEE_TYPE.HANDLER],
    ]
    const uniqueHandlerList = combinedHandlerList.filter(
      (item, index, self) =>
        index ===
        self.findIndex(
          t => t.id === item.id && t.assignee_type === item.assignee_type
        )
    )
    setHandlerList(uniqueHandlerList)

    const combinedFollowerList = [
      ...selectUserData[ASSIGNEE_TYPE.FOLLOWER],
      ...selectDepartmentData[ASSIGNEE_TYPE.FOLLOWER],
      ...selectGroupData[ASSIGNEE_TYPE.FOLLOWER],
    ]
    const uniqueFollowerList = combinedFollowerList.filter(
      (item, index, self) =>
        index ===
        self.findIndex(
          t => t.id === item.id && t.assignee_type === item.assignee_type
        )
    )
    setFollowerList(uniqueFollowerList)

    const handlerFollowerList = [
      ...selectUserData[ASSIGNEE_TYPE.COMBINER],
      ...selectDepartmentData[ASSIGNEE_TYPE.COMBINER],
      ...selectGroupData[ASSIGNEE_TYPE.COMBINER],
    ]
    const uniqueCombinedList = handlerFollowerList.filter(
      (item, index, self) =>
        index ===
        self.findIndex(
          t => t.id === item.id && t.assignee_type === item.assignee_type
        )
    )

    setCombinerList(uniqueCombinedList)
  }, [selectUserData, selectDepartmentData, selectGroupData])

  const processedFollowerList = useMemo(() => {
    if (!followerList || !allDataGroupList) return followerList

    return followerList.map(assignee => {
      if (assignee.assignee_type === 'USER') {
        for (const group of allDataGroupList) {
          const user = group.groupUsers.find(
            user => String(user.id) === assignee.id
          )
          if (user) {
            return {
              ...assignee,
              full_name: user.user.name_lowercase.toUpperCase(),
            }
          }
        }
      }
      return assignee
    })
  }, [followerList, allDataGroupList])

  const processedCombinerList = useMemo(() => {
    if (!combinerList || !allDataGroupList) return combinerList

    return combinerList.map(assignee => {
      if (assignee.assignee_type === 'USER') {
        for (const group of allDataGroupList) {
          const user = group.groupUsers.find(
            user => String(user.id) === assignee.id
          )
          if (user) {
            return {
              ...assignee,
              full_name: user.user.name_lowercase.toUpperCase(),
            }
          }
        }
      }
      return assignee
    })
  }, [combinerList, allDataGroupList])

  useEffect(() => {
    ;(async () => {
      if (authenticationStore.currentUser) {
        try {
          loadingAnimationStore.showSpinner(true)
          // await userGroupStore.getAllGroupList()
        } catch (err) {
          console.log(err)
        } finally {
          loadingAnimationStore.showSpinner(false)
        }
      }
    })()
  }, [authenticationStore.currentUser])

  useEffect(() => {
    if (!isVisible) return
    if (
      selectUserData[ASSIGNEE_TYPE.HANDLER].length === 0 &&
      selectUserData[ASSIGNEE_TYPE.FOLLOWER].length === 0
    ) {
      selectPeopleStore.setSelectUserData(
        selectPeopleStore.convertSelectDataObj(userList)
      )
    }
    if (
      selectDepartmentData[ASSIGNEE_TYPE.HANDLER].length === 0 &&
      selectDepartmentData[ASSIGNEE_TYPE.FOLLOWER].length === 0
    ) {
      selectPeopleStore.setSelectDepartmentData(
        selectPeopleStore.convertSelectDataObj(departmentList)
      )
    }
    if (
      selectGroupData[ASSIGNEE_TYPE.HANDLER].length === 0 &&
      selectGroupData[ASSIGNEE_TYPE.FOLLOWER].length === 0
    ) {
      selectPeopleStore.setSelectGroupData(
        selectPeopleStore.convertSelectDataObj(groupList)
      )
    }
  }, [originDepartmentWithUserList])

  useEffect(() => {
    if (isVisible && feedbackDetailData) {
      form.setFieldsValue({
        title: feedbackDetailData.title,
        documentNumber: toDisplayDocumentNumber(
          feedbackDetailData.documentNumber
        ),
        content: feedbackDetailData.content,
        startDate: moment(feedbackDetailData.startDate),
        endDate: moment(feedbackDetailData.endDate),
        basis: feedbackDetailData.legalBasis,
        purpose: feedbackDetailData.purpose,
        isTTr: feedbackDetailData.isTTr || false,
      })

      const comments = feedbackDetailData.feedbackComments.map(comment => ({
        id: comment.id,
        content: comment.content || '',
      }))
      setOtherContentList(
        comments.length > 0 ? comments : [{ id: Date.now(), content: '' }]
      )

      // Set initial file lists and original states
      const initialFileList =
        feedbackDetailData?.fileIdAttachment
          ?.filter((v, i, a) => a.findIndex(t => t.fileId === v.fileId) === i)
          ?.map(file => ({
            fileId: file.fileId,
            name: file.fileName,
            uid: file.fileId.toString(),
          })) || []
      setFileList(initialFileList)
      setOriginalFileList(initialFileList)

      const initialExpailFile =
        feedbackDetailData?.explanatoryDocument
          ?.filter((v, i, a) => a.findIndex(t => t.fileId === v.fileId) === i)
          ?.map(file => ({
            fileId: file.fileId,
            name: file.fileName,
            uid: file.fileId.toString(),
          })) || []
      setExpailFile(initialExpailFile)
      setOriginalExpailFile(initialExpailFile)
    }
  }, [isVisible, feedbackDetailData, form])

  const handleChangeFile = useCallback(
    info => {
      if (info.fileList.length === 0) {
        form.setFieldsValue({ file_upload: undefined })
        setFileList([])
        return
      }

      setFileList(prevFileList => {
        const newFiles = info.fileList.filter(file => file.originFileObj)
        const oldFiles = prevFileList.filter(
          file => file.fileId && !file.originFileObj
        )
        const combinedFiles = [...oldFiles, ...newFiles]
        const uniqueFiles = combinedFiles.filter(
          (file, index, self) =>
            index ===
            self.findIndex(
              f => f.name === file.name && f.fileId === file.fileId
            )
        )
        return uniqueFiles
      })
    },
    [form]
  )

  const handleChangeExplainFile = useCallback(
    info => {
      if (info.fileList.length === 0) {
        form.setFieldsValue({ explain_file: undefined })
        setExpailFile([])
        return
      }

      setExpailFile(prevExpailFile => {
        const newFiles = info.fileList.filter(file => file.originFileObj)
        const oldFiles = prevExpailFile.filter(
          file => file.fileId && !file.originFileObj
        )
        const combinedFiles = [...oldFiles, ...newFiles]
        const uniqueFiles = combinedFiles.filter(
          (file, index, self) =>
            index ===
            self.findIndex(
              f => f.name === file.name && f.fileId === file.fileId
            )
        )
        return uniqueFiles
      })
    },
    [form]
  )

  const handleOtherContentChange = useCallback((id, content) => {
    setOtherContentList(prevList =>
      prevList.map(item => (item.id === id ? { ...item, content } : item))
    )
  }, [])

  const handleAddOtherContent = useCallback(() => {
    const newContent = { id: Date.now(), content: '' }
    setOtherContentList(prevList => [...prevList, newContent])
  }, [])

  const handleRemoveOtherContent = useCallback(id => {
    setOtherContentList(prevList => prevList.filter(item => item.id !== id))
    otherContentRefs.current = otherContentRefs.current.filter(
      ref => ref.id !== id
    )
  }, [])

  const finalFollowerList = useMemo(() => {
    if (!processedFollowerList || !originGroupList) return processedFollowerList

    return processedFollowerList.map(item1 => {
      const matchedGroup = originGroupList.find(
        item2 => item2.id === parseInt(item1.id)
      )
      if (matchedGroup) {
        return { ...item1, full_name: matchedGroup.name }
      }
      return item1
    })
  }, [processedFollowerList, originGroupList])

  const finalCombinerList = useMemo(() => {
    if (!processedCombinerList || !originGroupList) return processedCombinerList

    return processedCombinerList.map(item1 => {
      const matchedGroup = originGroupList.find(
        item2 => item2.id === parseInt(item1.id)
      )
      if (matchedGroup) {
        return { ...item1, full_name: matchedGroup.name }
      }
      return item1
    })
  }, [processedCombinerList, originGroupList])

  const onFinish = useCallback(
    async values => {
      const { startDate, endDate } = values
      setIsSubmitting(true)
      const otherContentData = otherContentRefs.current.map(ref => ({
        id: ref.id,
        content: ref.ref ? ref.ref.editor.getData() : '',
      }))

      try {
        // 1. Separate old and new files for fileIdAttachment
        const oldFiles = fileList.filter(
          file => file.fileId && !file.originFileObj
        )
        const newFiles = fileList.filter(file => file.originFileObj)

        // 2. Separate old and new files for explanatoryDocument
        const oldExplainFiles = expailFile.filter(
          file => file.fileId && !file.originFileObj
        )
        const newExplainFiles = expailFile.filter(file => file.originFileObj)

        // 3. Upload new files
        const batchUploadArr = newFiles.map(file => {
          const formData = new FormData()
          formData.append('file', file.originFileObj)
          return fileStore.uploadFile(formData)
        })
        const batchUploadExplainArr = newExplainFiles.map(file => {
          const formData = new FormData()
          formData.append('file', file.originFileObj)
          return fileStore.uploadFile(formData)
        })

        const uploadResponses = await Promise.all(batchUploadArr)
        const uploadExplainResponses = await Promise.all(batchUploadExplainArr)

        // 4. Get file IDs from uploads
        const newFileIds = uploadResponses.map(response => ({
          code: response.data.file_id,
          name: response.data.file_name,
        }))
        const newExplainFileIds = uploadExplainResponses.map(response => ({
          code: response.data.file_id,
          name: response.data.file_name,
        }))

        // 5. Get file IDs from old files
        const oldFileIds = oldFiles.map(file => ({
          code: file.fileId,
          name: file.name,
        }))
        const oldExplainFileIds = oldExplainFiles.map(file => ({
          code: file.fileId,
          name: file.name,
        }))

        // 6. Compute afterFiles and originalFiles for fileIdAttachment
        const afterFiles = [...oldFileIds, ...newFileIds]
        const originalFiles = originalFileList.map(file => ({
          code: file.fileId,
          name: file.name,
        }))

        const originFileCodes = originalFiles.map(file => file.code)
        const afterFileCodes = afterFiles.map(file => file.code)

        const fileIdAttachmentNewItems = afterFiles.filter(
          file => !originFileCodes.includes(file.code)
        )
        const fileIdAttachmentRemoveItems = originalFiles.filter(
          file => !afterFileCodes.includes(file.code)
        )

        // 7. Compute afterFiles and originalFiles for explanatoryDocument
        const afterExplainFiles = [...oldExplainFileIds, ...newExplainFileIds]
        const originalExplainFiles = originalExpailFile.map(file => ({
          code: file.fileId,
          name: file.name,
        }))

        const originExplainFileCodes = originalExplainFiles.map(
          file => file.code
        )
        const afterExplainFileCodes = afterExplainFiles.map(file => file.code)

        const explanatoryDocumentNewItems = afterExplainFiles.filter(
          file => !originExplainFileCodes.includes(file.code)
        )
        const explanatoryDocumentRemoveItems = originalExplainFiles.filter(
          file => !afterExplainFileCodes.includes(file.code)
        )

        // 8. Prepare other data
        const handlerData = handlerList.map(el => ({
          assignee_code: el.id,
          assignee_type: el.assignee_type,
          permission: el.permission,
        }))
        const managerData = finalFollowerList.map(el => ({
          assignee_code: el.id,
          assignee_type: el.assignee_type,
          permission: el.permission,
        }))

        const combinerData = finalCombinerList.map(el => ({
          assignee_code: el.id,
          assignee_type: el.assignee_type,
          permission: el.permission,
        }))

        setLegalBasisExport(BASIS_REF?.current?.editor.getData() || '')
        setAttachedDocsExport(ATTACHED_REF?.current?.editor.getData() || '')
        setOtherContentExport(OTHER_REF?.current?.editor.getData() || '')
        setFeedbackNumber(values.content)
        setCommentExport(
          otherContentData
            .filter(item => item.content !== '')
            .map(item => ({ id: item.id, content: item.content }))
        )

        if (endDate.isBefore(startDate)) {
          return message.info('Ngày kết thúc phải lớn hơn ngày bắt đầu!')
        }
        if (managerData.length === 0) {
          return message.info('Bạn chưa chọn Người theo dõi!')
        }
        if (handlerData.length === 0) {
          return message.info('Bạn chưa chọn người xử lý!')
        }

        const submitData = {
          id: feedbackDetailData.id,
          title: values.title,
          boardType: getBoardTypeByTab(feedbackTab),
          documentNumber: toStorageDocumentNumberByTab(
            values.documentNumber,
            feedbackTab
          ),
          startDate: startDate.toISOString(),
          endDate: endDate.toISOString(),
          legalBasis: BASIS_REF?.current?.editor.getData() || '',
          purpose: PURPOSE_REF?.current?.editor.getData() || '',
          attachedDocuments: ATTACHED_REF?.current?.editor.getData() || '',
          otherContent: OTHER_REF?.current?.editor.getData() || '',
          content: values.content,
          fileIdAttachment: {
            removeItems: fileIdAttachmentRemoveItems,
            newItems: fileIdAttachmentNewItems,
          },
          status: FEEDBACK_STATUS.PENDING,
          isTTr: values.isTTr || false,
          assignees: [
            ...new Set([...handlerData, ...managerData, ...combinerData]),
          ],
          feedbackComments: otherContentData
            .filter(item => item.content !== '')
            .map(item => ({ id: item.id, content: item.content })),
        }

        setSubmitData(submitData)

        const response = await FeedbackProcedureStore.updateFeedbackProcedure(
          submitData,
          feedbackDetailData.id
        )

        if (response.status === 200) {
          setIsVisible(false)
          message.success('Cập nhật thành công')
          form.resetFields()
          setOpinionContent(null)
          setBasis(null)
          setPurpose(null)
          setAttachedDocs(null)
          setOtherContent(null)
          setFileList([])
          setExpailFile([])
          setFollowerList([])
          setHandlerList([])
          selectPeopleStore.clearSelectUserData()
          selectPeopleStore.clearSelectDepartmentData()
          selectPeopleStore.clearSelectedHandlerAndFollower()
          fetchFeedback()
        } else {
          console.error('Error in form submission:', response)
        }
      } catch (error) {
        console.error('Error in form submission:', error)
        message.error('Đã có lỗi xảy ra!')
      } finally {
        setIsSubmitting(false)
      }
    },
    [
      fileList,
      expailFile,
      originalFileList,
      originalExpailFile,
      handlerList,
      finalFollowerList,
      finalCombinerList,
      feedbackDetailData,
      fileStore,
      FeedbackProcedureStore,
      form,
      selectPeopleStore,
      setIsVisible,
      fetchFeedback,
      feedbackTab,
    ]
  )

  const handleDeleteFile = useCallback(uid => {
    setFileList(prevFileList => prevFileList.filter(el => el.uid !== uid))
  }, [])

  const handleDeleteExplainFile = useCallback(uid => {
    setExpailFile(prevExpailFile => prevExpailFile.filter(el => el.uid !== uid))
  }, [])

  const handleOpenHandler = useCallback(() => {
    handleOpenSelectUserDepartmentPopup(ASSIGNEE_TYPE.HANDLER)
  }, [handleOpenSelectUserDepartmentPopup])

  const handleOpenFollower = useCallback(() => {
    handleOpenSelectUserDepartmentPopup(ASSIGNEE_TYPE.FOLLOWER)
  }, [handleOpenSelectUserDepartmentPopup])

  const handleOpenCombiner = useCallback(() => {
    handleOpenSelectUserDepartmentPopup(ASSIGNEE_TYPE.COMBINER)
  }, [handleOpenSelectUserDepartmentPopup])

  const handleCloseSelectUser = useCallback(() => {
    setIsVisibleSelectUserDepartmentPopup(false)
  }, [setIsVisibleSelectUserDepartmentPopup])

  const fileListItems = useMemo(() => {
    return fileList.map(file => (
      <FileItem key={file.uid}>
        <span>
          <FileTextOutlined style={{ marginRight: 5 }} />
          {file.name}
        </span>
        <FileAction>
          <Tooltip title={'Xóa'}>
            <Button
              type={'text'}
              icon={<DeleteOutlined style={{ color: redPrimary }} />}
              onClick={() => handleDeleteFile(file.uid)}
            />
          </Tooltip>
        </FileAction>
      </FileItem>
    ))
  }, [fileList, handleDeleteFile])

  const explainFileListItems = useMemo(() => {
    return expailFile.map(file => (
      <FileItem key={file.uid}>
        <span>
          <FileTextOutlined style={{ marginRight: 5 }} />
          {file.name}
        </span>
        <FileAction>
          <Tooltip title={'Xóa'}>
            <Button
              type={'text'}
              icon={<DeleteOutlined style={{ color: redPrimary }} />}
              onClick={() => handleDeleteExplainFile(file.uid)}
            />
          </Tooltip>
        </FileAction>
      </FileItem>
    ))
  }, [expailFile, handleDeleteExplainFile])

  const handlerListTags = useMemo(() => {
    return handlerList.map(el => (
      <Tag
        className={'tag-selected'}
        color={'blue'}
        style={{ marginTop: '10px' }}
        key={el.id}
        closable
        onClose={() => selectPeopleStore.handleRemoveSelect(el)}>
        <AvatarHasName
          imgId={el.image_id}
          size={22}
          name={el.full_name}
          icon={
            (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
              <BankOutlined />
            )) ||
            (el.assignee_type === ASSIGNEE_TYPE.GROUP && <TeamOutlined />)
          }
        />
      </Tag>
    ))
  }, [handlerList, selectPeopleStore])

  const followerListTags = useMemo(() => {
    return finalFollowerList.map(el => (
      <Tag
        className={'tag-selected'}
        color={'blue'}
        style={{ marginTop: '10px' }}
        key={el.id}
        closable
        onClose={() => selectPeopleStore.handleRemoveSelect(el)}>
        <AvatarHasName
          imgId={el.image_id}
          size={22}
          name={el.full_name}
          icon={
            (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
              <BankOutlined />
            )) ||
            (el.assignee_type === ASSIGNEE_TYPE.GROUP && <TeamOutlined />)
          }
        />
      </Tag>
    ))
  }, [finalFollowerList, selectPeopleStore])

  const combinerListTags = useMemo(() => {
    return finalCombinerList.map(el => (
      <Tag
        className={'tag-selected'}
        color={'blue'}
        style={{ marginTop: '10px' }}
        key={el.id}
        closable
        onClose={() => selectPeopleStore.handleRemoveSelect(el)}>
        <AvatarHasName
          imgId={el.image_id}
          size={22}
          name={el.full_name}
          icon={
            (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
              <BankOutlined />
            )) ||
            (el.assignee_type === ASSIGNEE_TYPE.GROUP && <TeamOutlined />)
          }
        />
      </Tag>
    ))
  }, [finalCombinerList, selectPeopleStore])

  const otherContentItems = useMemo(() => {
    return otherContentList.map((item, index) => (
      <div key={item.id} style={{ position: 'relative', marginBottom: '16px' }}>
        <RichEditor
          EDITOR_REF={el => {
            otherContentRefs.current[index] = { id: item.id, ref: el }
          }}
          editorContent={item.content}
          height={100}
          onChange={content => handleOtherContentChange(item.id, content)}
        />
        {otherContentList.length > 1 && (
          <Button
            type="text"
            icon={<DeleteOutlined style={{ color: 'red' }} />}
            onClick={() => handleRemoveOtherContent(item.id)}
            style={{ position: 'absolute', top: '0', right: '-27px' }}
          />
        )}
      </div>
    ))
  }, [otherContentList, handleOtherContentChange, handleRemoveOtherContent])

  return (
    <>
      <style>
        {`
          .feedback-board-datetime-no-ok .ant-picker-ok {
            display: none;
          }
        `}
      </style>
      <Modal
        title="Cập nhật quy trình lấy ý kiến"
        visible={isVisible}
        onCancel={handleCancel}
        footer={null}
        width={900}
        wrapClassName="custom-modal-wrapper"
        style={{ top: 40 }}
        maskClosable={false}>
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          style={{ maxWidth: '800px', margin: '0 auto' }}>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                label="Số hồ sơ"
                name="documentNumber"
                rules={[
                  { required: true, message: 'Vui lòng nhập số hồ sơ!' },
                ]}>
                <Input
                  placeholder="Nhập số hồ sơ"
                  suffix={`/${getPlykSuffixByTab(feedbackTab)}`}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label="Tiêu đề"
                name="title"
                rules={[{ required: true, message: 'Vui lòng nhập tiêu đề!' }]}>
                <Input placeholder="Nhập tiêu đề" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Form.Item
                label="Ngày bắt đầu"
                name="startDate"
                rules={[
                  { required: true, message: 'Vui lòng nhập ngày bắt đầu!' },
                ]}>
                <DatePicker
                  showTime={{ format: 'HH:mm' }}
                  format={'DD/MM/YYYY HH:mm'}
                  popupClassName="feedback-board-datetime-no-ok"
                  onSelect={value => form.setFieldsValue({ startDate: value })}
                  onChange={value => form.setFieldsValue({ startDate: value })}
                  style={{ width: '100%' }}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Ngày kết thúc"
                name="endDate"
                rules={[
                  { required: true, message: 'Vui lòng nhập ngày kết thúc!' },
                ]}>
                <DatePicker
                  showTime={{ format: 'HH:mm' }}
                  format={'DD/MM/YYYY HH:mm'}
                  popupClassName="feedback-board-datetime-no-ok"
                  onSelect={value => form.setFieldsValue({ endDate: value })}
                  onChange={value => form.setFieldsValue({ endDate: value })}
                  style={{ width: '100%' }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={[16, 16]}>
            <Col span={8}>
              <span>
                <span
                  style={{
                    color: '#ff4d4f',
                    fontFamily: 'SimSun, sans-serif',
                    marginRight: '-4px',
                  }}>
                  *{' '}
                </span>
                <span style={{ marginRight: '10px' }}>Người xử lý</span>
              </span>
              <Space>
                <Tooltip title="Chọn người dùng" color={blue}>
                  <Button
                    className="select-user-icon-btn"
                    icon={<UserOutlined style={{ color: blue }} />}
                    onClick={handleOpenHandler}
                  />
                </Tooltip>
              </Space>
              <SelectList>{handlerListTags}</SelectList>
            </Col>

            <Col span={8}>
              <span>
                <span
                  style={{
                    color: '#ff4d4f',
                    fontFamily: 'SimSun, sans-serif',
                    marginRight: '-4px',
                  }}>
                  *{' '}
                </span>
                <span style={{ marginRight: '10px' }}>
                  Ý kiến của Ban KS/Ban KTNB
                </span>
              </span>
              <Space>
                <Tooltip title="Chọn người dùng" color={blue}>
                  <Button
                    className="select-user-icon-btn"
                    icon={<UserOutlined style={{ color: blue }} />}
                    onClick={handleOpenFollower}
                  />
                </Tooltip>
              </Space>
              <SelectList>{followerListTags}</SelectList>
            </Col>

            <Col span={8}>
              <span>
                <span style={{ marginRight: '10px' }}>Người theo dõi</span>
              </span>
              <Space>
                <Tooltip title="Chọn người dùng" color={blue}>
                  <Button
                    className="select-user-icon-btn"
                    icon={<UserOutlined style={{ color: blue }} />}
                    onClick={handleOpenCombiner}
                  />
                </Tooltip>
              </Space>
              <SelectList>{combinerListTags}</SelectList>
            </Col>
          </Row>

          <Tabs defaultActiveKey="1" destroyInactiveTabPane={false}>
            <Tabs.TabPane tab="Nội dung lấy ý kiến" key="1" forceRender>
              <Form.Item label="Nội dung lấy ý kiến">
                {otherContentItems}
                <Button
                  type="link"
                  className="icon-btn"
                  htmlType="button"
                  icon={
                    <AddCircleOutlineIcon
                      style={{ color: blue, width: 16, height: 16 }}
                    />
                  }
                  onClick={handleAddOtherContent}>
                  Thêm nội dung ý kiến khác
                </Button>
              </Form.Item>
            </Tabs.TabPane>
            <Tabs.TabPane tab="Căn cứ" key="2" forceRender>
              <Form.Item label="Căn cứ" name="basis">
                <RichEditor
                  EDITOR_REF={BASIS_REF}
                  editorContent={feedbackDetailData.legalBasis}
                />
              </Form.Item>
            </Tabs.TabPane>
            <Tabs.TabPane tab="Mục đích" key="3" forceRender>
              <Form.Item label="Mục đích" name="purpose">
                <RichEditor
                  EDITOR_REF={PURPOSE_REF}
                  editorContent={feedbackDetailData.purpose}
                />
              </Form.Item>
            </Tabs.TabPane>

            <Tabs.TabPane tab="Quá trình lấy ý kiến" key="4" forceRender>
              <Form.Item label="Quá trình lấy ý kiến" name="otherContent">
                <RichEditor
                  EDITOR_REF={OTHER_REF}
                  editorContent={feedbackDetailData.otherContent}
                />
              </Form.Item>
            </Tabs.TabPane>
            <Tabs.TabPane tab="Tài liệu đính kèm" key="5" forceRender>
              <Form.Item label={'Tài liệu đính kèm:'} name={'file'}>
                <Upload.Dragger
                  multiple={true}
                  beforeUpload={() => false}
                  onChange={handleChangeFile}
                  showUploadList={false}
                  className="custom-dragger-upload bg-white">
                  <DraggerUploadButton />
                </Upload.Dragger>
                <SignDocumentList>{fileListItems}</SignDocumentList>
              </Form.Item>
            </Tabs.TabPane>
          </Tabs>

          <div className="custom-create-page-footer-sticky">
            <Button htmlType="reset" danger onClick={handleCancel}>
              Hủy bỏ
            </Button>

            <Button type="primary" htmlType="submit" disabled={isSubmitting}>
              Tạo mới
            </Button>
          </div>
        </Form>
      </Modal>
      <SelectPeoplePopup
        onlyOneUser={
          selectPeopleStore.assigneePopupType === ASSIGNEE_TYPE.LEADER
        }
        handleCancelSelectUser={handleCancelSelectUserDepartment}
        handleSubmitSelectUser={handleCloseSelectUser}
        isVisibleSelectPeoplePopup={isVisibleSelectUserDepartmentPopup}
      />
      <div style={{ display: 'none' }}>
        <ExportPdf
          feedbackDetailData={feedbackDetailData}
          selectedOption={selectedOption}
          comment={null}
          feedbackTab={feedbackTab}
          submitData={submitData}
          legalBasisExport={legalBasisExport}
          attachedDocsExport={attachedDocsExport}
          otherContentExport={otherContentExport}
          commentExport={commentExport}
          fullNamecreator={fullNamecreator}
          feedbackNumber={feedbackNumber}
        />
      </div>
    </>
  )
}
FeedbackBoardUpdate.propTypes = {}
export default memo(
  inject(
    'loadingAnimationStore',
    'selectPeopleStore',
    'fileStore',
    'FeedbackProcedureStore',
    'departmentStore',
    'userGroupStore',
    'authenticationStore'
  )(observer(FeedbackBoardUpdate))
)
